<div fxLayout="row" class="container">
    @if (emailSent) {
        <div fxLayout="row" fxFlex="100%" fxLayoutAlign="center center">
            <mat-label style="padding: 100px">
                <mat-icon class="fade-in" style="font-size: 6em !important;">thumb_up</mat-icon>
            </mat-label>
        </div>
    }
    @if (!emailSent) {
        <div fxLayout="row" fxFlex="100%" fxLayoutAlign="center center">
            <!--                <div class="container" *ngIf="!post; else forminfo">-->
            <div class="container">
                <form [formGroup]="formGroup" (ngSubmit)="sendEmail(formGroup.value)" class="form">
                    <!--                <mat-select formControlName="topic" class="form-control" [value]="0" style="padding-bottom: 30px">-->
                    <!--                    <mat-option *ngFor="let topic of topics; let index=index" [value]="index">-->
                    <!--                        {{topic.value}}-->
                    <!--                    </mat-option>-->
                    <!--                </mat-select>-->
                    <mat-form-field class="form-element">
                        <input inputrestriction="basic1" matInput placeholder="* {{'general.emailAddress' | transloco}}" formControlName="email">
                        @if (!formGroup.controls['email'].valid && formGroup.controls['email'].touched) {
                            <mat-error>
                                {{ getErrorEmail() }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="form-element">
                        <input inputrestriction="basic1" matInput placeholder="* {{'general.fullName' | transloco}}" formControlName="name">
                        @if (!name.valid && name.touched) {
                            <mat-error>
                                {{ titleAlert }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="form-element">
                        @if (unsubscribeMode) {
                            <textarea cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" #autosize="cdkTextareaAutosize" formControlName="description" matInput
                                      placeholder="* reason for unsubscribing"></textarea>
                        }
                        @if (!unsubscribeMode) {
                            <textarea cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" #autosize="cdkTextareaAutosize" formControlName="description" matInput
                                      placeholder="* {{'general.howCanWeHelp' | transloco}}"></textarea>
                        }
                        @if (!formGroup.controls['description'].valid && formGroup.controls['description'].touched) {
                            <mat-error>
                                {{ 'general.req10To255' | transloco }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <!--                <div *ngIf="this.formGroup.controls['topic'].value === 0">-->
                    <!--                <div>-->
                    <!--                    <br/>-->
                    <!--                    <mat-label>{{'general.feedbackOnUs2' | transloco}}</mat-label>-->
                    <!--                    <mat-form-field class="form-element">-->
                    <!--                            <textarea cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" #autosize="cdkTextareaAutosize" formControlName="feedback" matInput-->
                    <!--                                      placeholder="{{'general.improvement2' | transloco}}"></textarea>-->
                    <!--                        <mat-error *ngIf="!formGroup.controls['feedback'].valid && formGroup.controls['feedback'].touched">-->
                    <!--                            {{'general.req10To255' | transloco}}-->
                    <!--                        </mat-error>-->
                    <!--                    </mat-form-field>-->
                    <!--                    <mat-label>{{'general.giveUsScore' | transloco}}</mat-label>-->
                    <!--                    <div class="row" style="text-align: center">-->
                    <!--                        <ul class="list-inline rating-list" *ngFor="let star of stars; let i= index" style="display: inline-block">-->
                    <!--                            <li (click)="countStar(star)" id="{{'starId'+i}}" [ngClass]="{'selected': (star <= selectedStars)}"-->
                    <!--                                (mouseover)="addClass(star)" (mouseout)="removeClass(star)"> ★-->
                    <!--                            </li>-->
                    <!--                        </ul>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <!--                <br/>-->
                    <!--                <br/>-->
                    <!--                enable to show add to mass email list -->
                    <!--                <mat-checkbox labelPosition="before" (change)="toggleStayInTouch($event.checked, 1)">-->
                    <!--                </mat-checkbox>-->
                    <!--                Add me to your newsletter-->
                    <!--                <br/>-->
                    <!--                <mat-checkbox labelPosition="before" (change)="toggleStayInTouch($event.checked, 2)">-->
                    <!--                </mat-checkbox>-->
                    <!--                Allow us to contact you about news and updates-->
                    <!--                        <mat-form-field class="form-element">-->
                    <!--                            <textarea style="height: 100px; width: 240px" matInput placeholder="{{'general.howCanWeHelp' | transloco}}" formControlName="description"></textarea>-->
                    <!--                            <mat-error *ngIf="!formGroup.controls['description'].valid && formGroup.controls['description'].touched">-->
                    <!--                                Required field, must be between 5 and 10 characters.-->
                    <!--                            </mat-error>-->
                    <!--                        </mat-form-field>-->
                    <!--                        <div class="form-element">-->
                    <!--                            <mat-checkbox formControlName="validate" value="1">Require name to have at least 3 characters (demonstrates changing validation rules)</mat-checkbox>-->
                    <!--                        </div>-->
                    <div class="form-element">
                        <button mat-raised-button color="primary" type="submit" class="button" [disabled]="!formGroup.valid">
                            @if (unsubscribeMode === false) {
                                <span>
                                    <mat-icon>send</mat-icon>
                                    <span class="textButt">{{ 'general.sendEmail' | transloco }}</span>
                                </span>
                            }
                            @if (unsubscribeMode === true) {
                                <span>
                                    <mat-icon>remove_moderator</mat-icon>
                                    <span class="textButt">unsubscribe</span>
                                </span>
                            }
                        </button>
                    </div>
                    <!--                <button color="warn" mat-raised-button (click)="openChatGPT()">-->
                    <!--                    <mat-icon>auto_awesome</mat-icon>-->
                    <!--                    Start AI Agent...-->
                    <!--                </button>-->
                    <!--                <br/>-->
                    <!--                <mat-label>-->
                    <!--                    trained with Chat GPT-->
                    <!--                </mat-label>-->
                    <!--                <mat-label>-->
                    <!--                    for DigitalSignage.com (beta)-->
                    <!--                </mat-label>-->
                    <!--                <br/>-->
                    <!--                <br/>-->
<!--                    <mat-label>-->
<!--                        {{ 'general.waitForHuman' | transloco }}-->
<!--                    </mat-label>-->
                    <div style="width: 100%; text-align: center; margin-top: 10px;">
                        <mat-label style="font-size: 1.2em">OR</mat-label>
                        <br/>
                        <br/>
                        <button color="warn" mat-raised-button (click)="openChatGPT($event)">
                            <mat-icon>auto_awesome</mat-icon>
                            <span>{{'general.speakAiAgent' | transloco}}</span>
                        </button>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                </form>
            </div>
            <!--                <ng-template #forminfo>-->
            <!--                    <div class="container">-->
            <!--                        {{ post | json }}-->
            <!--                    </div>-->
            <!--                </ng-template>-->
        </div>
    }
</div>
